import React, { useState } from 'react';
import { Global } from '@emotion/core';
import { ThreeDotMenu } from 'components/EpisodeEditorPublish/components/InteractivePoll/ThreeDotMenu';
import { POLL_TYPE } from 'modules/AnchorAPI/v3/episodes/fetchInteractivityPoll';
import { useFetchPoll } from 'hooks/useInteractivityPolls';
import { SpotifyLogo } from 'components/svgs/SpotifyLogo';
import { Modal } from 'shared/Modal';
import { InteractivePollForm } from '../InteractivePollForm';
import {
  InteractivePollContainer,
  Title,
  PollBanner,
  CopyContainer,
  FormContainer,
  PollModalTitle,
  OpenModalButton,
  PollQuestionDisplayCopy,
  StatusText,
  Optional,
  TopBarContainer,
  BootstrapOverrideStyles,
} from './styles';

export function InteractivePoll({
  episodeId,
  userId,
}: {
  episodeId: string;
  userId: number;
}) {
  const { data, status } = useFetchPoll(episodeId);
  const [isOpen, setIsOpen] = useState(false);
  if (!data || status === 'loading') return null;
  const { polls = [] } = data;
  const poll = polls[0] || {};

  const initialValues = {
    question: poll.question,
    opening_date: poll.opening_date,
    closing_date: poll.closing_date,
    options: poll.options || [{ description: '' }, { description: '' }],
    type: POLL_TYPE[poll.type] || POLL_TYPE.SINGLE_CHOICE,
    entity_timestamp_ms: poll.entity_timestamp_ms || 0,
    name: episodeId,
    published: true,
  };

  const getPollStatusText = () => {
    switch (poll.status) {
      case 'LIVE':
        return 'Published';
      case 'CLOSED':
        return 'Closed';
      case 'DRAFT':
      default:
        return 'Draft';
    }
  };

  return (
    <InteractivePollContainer>
      <Global styles={BootstrapOverrideStyles} />
      <Title>Polls</Title> <Optional>(optional)</Optional>
      <PollBanner>
        <CopyContainer>
          <TopBarContainer>
            <SpotifyLogo width={63} />
            {poll.id && (
              <ThreeDotMenu
                episodeId={episodeId}
                userId={userId}
                status={poll.status}
              />
            )}
          </TopBarContainer>
          <PollQuestionDisplayCopy>
            {polls.length
              ? poll.question
              : `Engage with listeners directly from your episode with Polls`}
          </PollQuestionDisplayCopy>
          {poll.id && <StatusText>Status: {getPollStatusText()}</StatusText>}
        </CopyContainer>
        <OpenModalButton
          kind="button"
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          color="purple"
        >
          {polls.length ? 'Edit poll' : 'Add a poll'}
        </OpenModalButton>
      </PollBanner>
      {isOpen && (
        <Modal
          isShowing={true}
          isShowingCloseButton
          onClickOutside={() => setIsOpen(false)}
          onClickClose={() => setIsOpen(false)}
          renderContent={() => (
            <FormContainer>
              <PollModalTitle>
                {polls.length ? 'Edit' : 'Add a new'} poll
              </PollModalTitle>
              <InteractivePollForm
                onSuccess={() => setIsOpen(false)}
                initialValues={initialValues}
                poll={poll}
                episodeId={episodeId}
              />
            </FormContainer>
          )}
        />
      )}
    </InteractivePollContainer>
  );
}
